// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"483":"549e308990e635f9","888":"09d0f6b520c9f5ff"}[chunkId] + ".css";
};